import React from 'react';
import ReactDOM from 'react-dom/client';

import '@asd-stan/i18n/i18n';
import '@asd-stan/injector/init-injector';
import '@asd-stan/injector/init-injector';

import { App } from './App';
import reportWebVitals from './reportWebVitals';
import './ui-kit/styles/index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
